import { ActivityIndicator, Dimensions, Modal, PixelRatio, StyleSheet, Text, TextInput, TouchableOpacity, View } from 'react-native'
import React, { useEffect, useState } from 'react'
import Colours from '../../utils/Colours'
import SearchIcon from '../../icons/SearchIcon'
import useAxiosPrivate from '../../hooks/useAxiosPrivate'
import PartyHeatComp from '../../partyHeatComp/PartyHeatComp'
import axios from 'axios'
import QRTableScan from './QRTableScan'
import TopHeaderComponent from '../aTopHeader/TopHeaderComponent'
import AppTextInput from '../../utils/ColourThemes/AppTextInput'



const { width, height } = Dimensions.get('window');
// Base width (e.g., iPhone 11 - 375px)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

// Function to adjust font size
const dynamicFontSize = (size) => {
    const scaleFactor = Math.min(width / BASE_WIDTH, height / BASE_HEIGHT);
    const newSize = size * scaleFactor;

    return Math.round(PixelRatio.roundToNearestPixel(newSize));
};

// Function for dynamic spacing (padding, margin, gap)
const dynamicSpacing = (size) => (width / BASE_WIDTH) * size;

// Function for dynamic sizing (width, height, borderRadius)
const dynamicSize = (size) => (width / BASE_WIDTH) * size;

const PurchaseFromTable = ({
    scrollToTop,
    useCaption,
    tableToUseID,
    contributors,
    usePull,
    useContributionAmount,
    tableDataToUse,

    showTheDoingsAmount,
    setShowTheDoingsAmount,
    showA_PartyHeatScreen,
    setShowA_PartyHeatScreen,
    showPartyHeatComp,
    setShowPartyHeatComp,

    successMessage,
    setSuccessMessage,

    hideAllPayScreens,
}) => {

    const [isFormContainerClicked, setIsFormContainerClicked] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [isSearchVisible, setIsSearchVisible] = useState(false)
    const [isPartyCompVisible, setIsPartyCompVisible] = useState(false)
    const [activeChoice, setActiveChoice] = useState('')
    const [pullSearchResults, setPullSearchResults] = useState([])
    const [showQRTableScan, setShowQRTableScan] = useState(false)

    useEffect(() => {
        handleShowHiddenComps()
    }, [activeChoice])

    useEffect(() => {
        //console.log('pullSearchResults', pullSearchResults)
    }, [pullSearchResults])


    const axiosPrivate = useAxiosPrivate()

    // const searchPulls = async (searchTerm) => {
    let debounceTimer = null;
    let cancelToken = null; // To cancel previous requests

    const searchPulls = (searchTerm) => {

        // Clear the debounce timer
        clearTimeout(debounceTimer);


        debounceTimer = setTimeout(async () => {
            try {
                //console.log("searchTerm", searchTerm)

                if (!searchTerm.trim()) {
                    //console.log('No search Term')
                    setPullSearchResults([])

                    return;
                }

                setIsLoading(true)

                // Cancel the previous request if it's still ongoing
                if (cancelToken) {
                    cancelToken.cancel();
                }

                cancelToken = axios.CancelToken.source();


                const response = await axiosPrivate.get(`/pullsearch/pullsearch/${searchTerm}`, {
                    cancelToken: cancelToken.token,
                });
                if (response.status === 200 || response.status === 201) {
                    //console.log('response.data UsernameSearch', response.data)
                    // setIsPartyCompVisible(true)
                    setPullSearchResults(response.data)
                } else {
                    //console.error('Unexpected response:', response);
                    setPullSearchResults([]);
                }
            } catch (error) {
                //console.log('Search while performing search:', error);
                setPullSearchResults([]);

            } finally {
                setIsLoading(false)
            }
        }, 300); // Adjust the delay (300ms) as needed

    };

    const handleSelectedChoice = (choice) => {
        setActiveChoice(choice)
    }

    const handleShowHiddenComps = () => {
        if (activeChoice === 'search') {
            setIsSearchVisible(true)
        } else if (activeChoice === 'tva') {
            //console.log('tva')

            setIsSearchVisible(false)
            setShowQRTableScan(true)
        } else {
            //console.log('reservation')
            setIsSearchVisible(false)
        }
    }



    return (
        <View>
            {/* <View style={styles.celebratoryPullContainer}>
                <TouchableOpacity style={[
                    styles.dataContainer2,
                    { borderColor: activeChoice === 'search' ? Colours.PRIMARY : Colours.LIGHTGRAY },
                ]}
                    onPress={() => handleSelectedChoice('search')}
                >
                    <View style={styles.dataSubContainer}>
                        <View style={styles.captionAndDescribtion}>
                            <View style={styles.flatArrowContainer}>
                                <Text style={{ color: activeChoice === 'search' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>
                                    Search for shows, parties and experiences
                                </Text>
                            </View>
                        </View>
                    </View>
                </TouchableOpacity>

            </View> */}
            {isSearchVisible && <><View style={styles.celebratoryPullContainer2}>
                <View style={styles.JoinedNumber}>
                    <Text style={styles.searchTxt} >SEARCH </Text>
                    <Text style={styles.searchDemacateTxt}>|: </Text>
                </View>
                <Text style={styles.searchByLocateTxt}>
                    Search by Location, Promoter name or Party caption
                </Text>

                <View style={styles.searchBoxContainer}>
                    <View style={styles.SearchBox}>
                        <AppTextInput
                            style={[styles.inputTxt, isFormContainerClicked && styles.focusedBorder,
                                //{ borderColor: isFormContainerClicked ? Colours.PRIMARY : Colours.LIGHTGRAY },
                            ]}
                            placeholder="Search"
                            onFocus={() => setIsFormContainerClicked(true)}
                            onBlur={() => setIsFormContainerClicked(false)}
                            // value={tableCaption}
                            onChangeText={(searchTerm) => { searchPulls(searchTerm) }}
                        />
                    </View>
                    <View style={{ backgroundColor: Colours.DARKLIGHTGRAY, height: 30, width: 1, }}></View>
                    <SearchIcon color={Colours.DARKGRAY} />
                </View>
            </View>
                {isLoading && (
                    <View style={styles.loaderContainer}>
                        <ActivityIndicator size="large" color={Colours.PRIMARY} />
                    </View>
                )}

                {/* Display PartyHeatComp if results exist */}
                {!isLoading && Array.isArray(pullSearchResults) && pullSearchResults.length > 0 && (
                    <PartyHeatComp
                        pullSearchResults={pullSearchResults}
                        // scrollToTop={scrollToTop}
                        useCaption={useCaption}
                        tableToUseID={tableToUseID}
                        contributors={contributors}
                        usePull={usePull}
                        useContributionAmount={useContributionAmount}
                        tableDataToUse={tableDataToUse}

                        showTheDoingsAmount={showTheDoingsAmount}
                        setShowTheDoingsAmount={setShowTheDoingsAmount}
                        showA_PartyHeatScreen={showA_PartyHeatScreen}
                        setShowA_PartyHeatScreen={setShowA_PartyHeatScreen}
                        showPartyHeatComp={showPartyHeatComp}
                        setShowPartyHeatComp={setShowPartyHeatComp}

                        successMessage={successMessage}
                        setSuccessMessage={setSuccessMessage}

                        hideAllPayScreens={hideAllPayScreens}
                    />
                )}

            </>
            }

            {/* <View style={styles.celebratoryPullContainer2}>
                <TouchableOpacity style={[
                    styles.dataContainer2,
                    { borderColor: activeChoice === 'tva' ? Colours.PRIMARY : Colours.LIGHTGRAY },
                ]}
                    onPress={() => handleSelectedChoice('tva')}
                >
                    <View style={styles.dataSubContainer}>
                        <View style={styles.captionAndDescribtion}>
                            <View style={styles.flatArrowContainer}>
                                <Text style={{ color: activeChoice === 'tva' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>
                                    Table Value Access: Open your table for a QR code scan
                                </Text>
                            </View>
                        </View>
                    </View>
                </TouchableOpacity>
            </View> */}

            <View style={styles.celebratoryPullContainer2}>
                {/* <Text style={{ marginBottom: 10, color: Colours.DARKGRAY, fontSize: 15, fontFamily: 'Sen-Bold' }}>Testing the stuff</Text> */}
                <TouchableOpacity style={[
                    styles.dataContainer2,
                    { borderColor: activeChoice === 'reservation' ? Colours.PRIMARY : Colours.LIGHTGRAY },
                ]}
                    onPress={() => handleSelectedChoice('reservation')}
                >
                    {/*                     
                    <View style={styles.dataSubContainer}>
                        <View style={styles.captionAndDescribtion}>
                            <View style={styles.flatArrowContainer}>
                                <Text style={{ color: activeChoice === 'reservation' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular' }}>
                                    Book a reservation with any of our partners ( NightClubs, Lounge, Resturants )
                                </Text>
                            </View>
                        </View>
                    </View> */}


                    <View style={styles.dataSubContainer2}>
                        {/* <View style={styles.captionAndDescribtion}> */}
                        {/* <View style={styles.flatArrowContainer}> */}
                        <Text style={{ color: activeChoice === 'reservation' ? Colours.PRIMARY : Colours.DARKLIGHTGRAY, fontSize: dynamicFontSize(14), fontFamily: 'Sen-Regular', textAlign: 'center' }}>
                            Coming soon...
                        </Text>
                        {/* </View> */}
                        {/* </View> */}
                    </View>
                </TouchableOpacity>
            </View>
            <Modal
                animationType='fade'
                visible={showQRTableScan}
                onRequestClose={() => setShowQRTableScan(false)}
            >
                <TopHeaderComponent headerText={'Scan'} hideScreen={() => setShowQRTableScan(false)} />
                <QRTableScan />
            </Modal>
        </View>
    )
}

const styles = StyleSheet.create({
    celebratoryPullContainer: {
        display: 'flex',
        margin: dynamicSpacing(15),
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(15),
        backgroundColor: 'white',
        shadowColor: '#E8E8E8',
    },
    searchTxt: {
        marginTop: dynamicSpacing(10),
        marginBottom: dynamicSpacing(10),
        fontSize: dynamicFontSize(15),
        color: Colours.DARKLIGHTGRAY,
        fontFamily: 'Sen-Bold',
    },
    searchDemacateTxt: {
        paddingLeft: dynamicSpacing(1),
        paddingBottom: 0,
        color: Colours.PRIMARY,
        fontFamily: 'Sen-Regular',
    },
    searchByLocateTxt: {
        paddingLeft: dynamicSpacing(1),
        paddingBottom: 0,
        color: Colours.PRIMARY,
        fontFamily: 'Sen-Regular',
        width: dynamicSpacing(250),
    },
    celebratoryPullContainer2: {
        display: 'flex',
        margin: dynamicSpacing(15),
        marginTop: dynamicSpacing(15),
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(15),
        backgroundColor: 'white',
        shadowColor: '#E8E8E8',
    },
    JoinedNumber: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: dynamicSpacing(1),
    },
    searchBoxContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    inputTxt: {
        height: dynamicSpacing(40),
        width: dynamicSpacing(250),
        marginTop: dynamicSpacing(10),
        padding: dynamicSpacing(10),
        borderWidth: dynamicSpacing(2.5),
        borderColor: Colours.LIGHTGRAY,
        borderRadius: dynamicSize(7),
        fontFamily: 'Sen-Regular',
        fontSize: dynamicFontSize(15),
        backgroundColor: Colours.LIGHTGRAY,
        marginBottom: dynamicSpacing(10),
        marginRight: dynamicSpacing(10),
    },
    focusedBorder: {
        borderColor: Colours.PRIMARY,
        borderWidth: dynamicSpacing(2),
    },
    dataContainer2: {
        display: 'flex',
        borderWidth: dynamicSpacing(1),
        borderColor: Colours.PRIMARY_LIGHTER,
        padding: dynamicSpacing(15),
        borderRadius: dynamicSize(10),
    },
    dataSubContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    dataSubContainer2: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center'
    },
    flatArrowContainer: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    captionAndDescribtion: {
        display: 'flex',
    },
});

export default PurchaseFromTable
